import React from "react";
import "./MelodyBandSection.css";

const MelodyBandSection = () => {
  const bandBackground = {
    backgroundImage: `url(${process.env.PUBLIC_URL}/bandimg-optimized.jpg)`
  };

  return (
    <section className="section" id="melody-band">
      <div className="band-content" style={bandBackground}>
        <div className="band-image-container">
          <img
            src="/bandimg-optimized.jpg"
            alt="A melody Band performing"
            className="band-image lazy-image loaded"
            loading="lazy"
            decoding="async"
          />
        </div>
        <div className="band-details">
          <div className="band-info">
            <h3 className="band-name">
              A_Melody Band
              <img
                src="/band-logo.png"
                alt="A Melody Band Logo"
                className="band-logo lazy-image loaded"
              />
            </h3>

            <p className="band-description">
              A melody Band represents the perfect fusion of contemporary western
              and eastern-classical with local sensibilities. Their unique sound
              combines intricate melodies with powerful rhythmic vocals, creating
              an immersive musical experience that resonates with diverse
              audiences.
            </p>
            <div className="band-details-list">
              <div className="detail-item">
                <span className="detail-label">Formation:</span>
                <span className="detail-value">2024</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">Members:</span>
                <span className="detail-value">8 Musicians, 1 vocalist</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">Genre:</span>
                <span className="detail-value">Mixed</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">Albums:</span>
                <span className="detail-value">2 Studio Albums</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MelodyBandSection;
